
export class ResponseJardinModel{
    payload:JardinModel;

    constructor(){
        this.payload = new JardinModel();
    }
}
export class JardinModel{
    id:number;
    idJardinPeriodo:number;
    idUsuario:number;
    jardin:string;
    rbd:string;
    tipoJardin:string;
    estadoJardin:string;
    etapaJardin:number;
    estadoPEI:string;
    estadoRI:string;
    constructor(){
        this.id = 0;
        this.idJardinPeriodo = 0;
        this.idUsuario = 0;
        this.jardin = '';
        this.rbd = '';
        this.tipoJardin = '';
        this.estadoJardin = '';
        this.etapaJardin = 0;
        this.estadoPEI = '';
        this.estadoRI = '';
    }
}